import { FC, ReactNode } from 'react';

import { SxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { shouldForwardProp as sysShouldForwardProp } from '@mui/system';

import { gap } from './values';

interface ColumnProps {
  children: ReactNode;

  /**
   * Disable gap between children of the column.
   */
  disableGap?: boolean;

  sx?: SxProps;
}

const ColumnRoot = styled('div', {
  name: 'O2Column',
  slot: 'root',
  shouldForwardProp: (prop) => sysShouldForwardProp(prop) && prop !== 'disableGap',
})<ColumnProps>(({ disableGap, theme }) => {
  const flex = {
    display: 'flex',
    flexDirection: 'column',
  } as const;

  if (disableGap) return flex;

  return theme.breakpoints.keys.reduce(
    (prev, breakpoint) => ({
      ...prev,
      [theme.breakpoints.up(breakpoint)]: {
        gap: theme.spacing(gap[breakpoint]),
      },
    }),
    flex
  );
});

const Column: FC<ColumnProps> = (props) => {
  return <ColumnRoot {...props} />;
};

Column.displayName = 'Container.Column';

export default Column;
